import { Navigate, createBrowserRouter } from 'react-router-dom'
import Dashboard from './pages/Dashboard'
import Auth from './pages/Auth'
import PrivateRoute from './components/PrivateRoute'
import AlertPage from './pages/AlertPage'
import OrganizationSetting from './pages/OrganizationSetting'
import AlertIndicator from './pages/AlertIndicators'
import RuleSetting from './pages/RulesSetting'
import SettingDetails from './pages/RulesSetting/SettingDetails'
import AlertDashboard from './pages/AlertPage/AlertDashboard'
import InvestigationDashboard from './pages/InvestigationPage/InvestigationDashboard'
import HelpPage from './pages/HelpPage'
import Provider from './pages/InvestigationPage/Provider'
import AllProviders from './pages/InvestigationPage/AllProviders'
import ProvidersResult from './pages/InvestigationPage/ProvidersResult'
import ProviderInvestigation from './pages/InvestigationPage/ProviderInvestigation'
import ClientInvestigation from './pages/InvestigationPage/ClientInvestigation'
import Client from './pages/InvestigationPage/Client'
import AllClients from './pages/InvestigationPage/AllClients'
import ClientsResult from './pages/InvestigationPage/ClientsResult'
import HelpContent from './pages/HelpPage/HelpContent'
import Upload from './pages/Upload'
import EubaRules from './pages/EubaRules'
import EubaExceptions from './pages/EubaRules/EubaExceptions'
import UserManagement from './pages/UserManagement'
import PlatformLayout from './components/PlatformLayout'
import Login from './pages/Login'
import BreachManagement from './pages/BreachManagement'
import BreachManagementMainPage from './pages/BreachManagement/BreachManagementMainPage'
import UpdatePassword from './pages/UpdatePassword'
import Logout from './pages/Logout'

const router = createBrowserRouter([
  {
    path: '/auth',
    element: <Auth />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/logout',
    element: <Logout />,
  },
  {
    path: '/help',
    element: <HelpPage />,
    children: [
      { index: true, element: <HelpContent helpID='dashboard' /> },
      { path: 'dashboardHelp', element: <HelpContent helpID='dashboard' /> },
      { path: 'alertsHelp', element: <HelpContent helpID='alert' /> },
      { path: 'indicatorsHelp', element: <HelpContent helpID='indicator' /> },
      { path: 'providerSearchHelp', element: <HelpContent helpID='providerSearch' /> },
      {
        path: 'providerInvestigationHelp',
        element: <HelpContent helpID='providerInvestigation' />,
      },
      { path: 'clientSearchHelp', element: <HelpContent helpID='clientSearch' /> },
      { path: 'clientInvestigationHelp', element: <HelpContent helpID='clientInvestigation' /> },
      { path: 'orgSettingHelp', element: <HelpContent helpID='orgSetting' /> },
      { path: 'ruleSettingHelp', element: <HelpContent helpID='ruleSetting' /> },
    ],
  },
  {
    element: <PrivateRoute />,
    children: [
      {
        element: <PlatformLayout />,
        children: [
          { path: '/', element: <Dashboard /> },
          { path: '/breachManagement', element: <BreachManagement />},
          { path: '/breachManagement/breachManagementDetails', element: <BreachManagementMainPage /> },
          { path: '/userManagement', element: <UserManagement /> },
          { path: '/alerts', element: <AlertPage pageName='Alerts' /> },
          { path: '/indicators', element: <AlertIndicator /> },
          {
            path: '/provider',
            element: <Provider />,
            children: [
              { index: true, element: <AllProviders /> },
              { path: 'providersResult', element: <ProvidersResult /> },
              { path: 'providerInvestigation', element: <ProviderInvestigation /> },
            ],
          },
          {
            path: '/client',
            element: <Client />,
            children: [
              { index: true, element: <AllClients /> },
              { path: 'clientsResult', element: <ClientsResult /> },
              { path: 'clientInvestigation', element: <ClientInvestigation /> },
            ],
          },
          { path: '/organizationSetting', element: <OrganizationSetting /> },
          { path: '/detectionRules', element: <RuleSetting /> },
          { path: '/eubaRules', element: <EubaRules /> },
          { path: '/detectionRules/:id/edit', element: <SettingDetails /> },
          { path: '/eubaRules/:id/edit', element: <EubaExceptions /> },
          { path: '/alertDashboard', element: <AlertDashboard /> },
          { path: '/investigationDashboard', element: <InvestigationDashboard /> },
          { path: '/upload', element: <Upload /> },
          { path: '/password', element: <UpdatePassword />, },
          { path: '*', element: <Navigate to='/' replace /> },
        ],
      },
    ],
  },
])

export default router
